<template>
  <LcRadioCard
    :label="$t('account.payout.accounts.paypal')"
    label-class="paragraph-bold"
    :value="id"
  >
    <template #default>
      <PaymentMethodSymbols :filter="[type]" />
    </template>

    <template #bottom>
      {{ payPalPayerEmail }}
    </template>
  </LcRadioCard>
</template>

<script setup lang="ts">
import type { PayOutAccountPayPal } from '../../../../../core/api/shared/@types/generated/backend/graphql-schema-types'

type PayoutStoredMethodPayPalProps = Omit<PayOutAccountPayPal, '__typename'>

defineProps<PayoutStoredMethodPayPalProps>()
</script>
